import Input from 'antd/es/input';
import 'antd/lib/input/style';
export default Input;
